import { Box } from "@chakra-ui/react";
import { Heading, Text } from "@equidefi/ui";

interface EditCardProps {
  title: string;
  description: string;
}

export const EditCard = ({ title, description }: EditCardProps) => (
  <Box
    bg="white"
    borderRadius="lg"
    p="4"
    boxShadow="0 1px 2px rgba(0,0,0,0.2)"
    border="1px solid"
    borderColor="gray.100">
    <Heading as="h1" fontSize="24px" lineHeight="28px" fontWeight="700" mb="2.5">
      {title}
    </Heading>
    <Text m="0" fontSize="17px" lineHeight="26px">
      {description}
    </Text>
  </Box>
);
